export const sidebarTheme = {
  background: {
    main: "linear-gradient(180deg, #0a0f1a 0%, #11182a 100%)",
    logoBox: "transparent",
    logoutArea: "#141c2f",
    scrollbarThumb: "#2c3954",
  },

  menu: {
    selected: {
      background: "rgba(0, 127, 255, 0.18)", // glow from primary
      text: "#007FFF",
      icon: "#007FFF",
      verticalLine: "#007FFF",
    },
    hover: {
      backgroundTopLevel: "rgba(255,255,255,0.05)",
      backgroundSubmenu: "rgba(255,255,255,0.03)",
    },
    normal: {
      text: "#d0d7e5",
      iconTopLevel: "#7fa5d9", // softened version of #29446D
      iconSubmenu: "#5e779e",
      verticalLine: "rgba(255,255,255,0.1)",
    },
    collapse: {
      icon: "#5e779e",
    },
  },

  logout: {
    border: "#0000B2",
    text: "#4d5dff", // lighter variant of deep accent
    hoverBackground: "rgba(0, 0, 178, 0.16)",
  },

  border: {
    logoutArea: "#1c2438",
  },
} as const;

// export const sidebarTheme = {
//   background: {
//     main: "linear-gradient(180deg, #ffffff 0%, #f4f7fc 100%)",
//     logoBox: "transparent",
//     logoutArea: "#eef2f9",
//     scrollbarThumb: "#c7d2e5",
//   },

//   menu: {
//     selected: {
//       background: "rgba(0, 127, 255, 0.12)",
//       text: "#005FCC",
//       icon: "#005FCC",
//       verticalLine: "#007FFF",
//     },
//     hover: {
//       backgroundTopLevel: "rgba(0,0,0,0.04)",
//       backgroundSubmenu: "rgba(0,0,0,0.03)",
//     },
//     normal: {
//       text: "#2b3547",
//       iconTopLevel: "#29446D",
//       iconSubmenu: "#5b6c87",
//       verticalLine: "rgba(0,0,0,0.12)",
//     },
//     collapse: {
//       icon: "#5b6c87",
//     },
//   },

//   logout: {
//     border: "#0000B2",
//     text: "#0000B2",
//     hoverBackground: "rgba(0, 0, 178, 0.10)",
//   },

//   border: {
//     logoutArea: "#d4dceb",
//   },
// } as const;

// light theme version

// export const sidebarTheme = {
//   background: {
//     main: "linear-gradient(180deg, rgba(240,248,255,0.65) 0%, rgba(255,255,255,0.55) 100%)",
//     logoBox: "rgba(255,255,255,0.4)",
//     logoutArea: "rgba(255,255,255,0.35)",
//     scrollbarThumb: "rgba(180, 200, 220, 0.7)",
//   },

//   menu: {
//     selected: {
//       background: "rgba(56, 132, 255, 0.15)",
//       text: "#1a73e8",
//       icon: "#1a73e8",
//       verticalLine: "#1a73e8",
//     },
//     hover: {
//       backgroundTopLevel: "rgba(255,255,255,0.5)",
//       backgroundSubmenu: "rgba(255,255,255,0.35)",
//     },
//     normal: {
//       text: "#2a3540",
//       iconTopLevel: "#4b5c6b",
//       iconSubmenu: "#6b8295",
//       verticalLine: "rgba(0,0,0,0.08)",
//     },
//     collapse: {
//       icon: "#6b8295",
//     },
//   },

//   logout: {
//     border: "#ef5350",
//     text: "#d32f2f",
//     hoverBackground: "rgba(255, 235, 238, 0.7)",
//   },

//   border: {
//     logoutArea: "rgba(200,200,200,0.4)",
//   },
// } as const;
